import { TAB_META } from '~/consts/tab';
import { TabIds } from '~/definitions/tab';
import { getStore } from '~/mobx/AppStore';

// Fetches and initializes data for the given tab.
const fetchTabData = async (newTabId: TabIds) => {
    const {
        electionMenuStore,
        zipcodeStore,
        companyStore,
        adminStore,
        adminReportStore,
        reportStore,
        tabStore,
        candidateStore,
        generalSettingsStore,
        regionStore,
    } = getStore();

    const activeTabId = tabStore.activeTabId;
    const isCandidateOrPostalActiveTab =
        activeTabId === TAB_META.CANDIDATES.id || activeTabId === TAB_META.POSTAL_CODE.id;
    const isNonCandidateOrPostalNewTab = newTabId !== TAB_META.CANDIDATES.id && newTabId !== TAB_META.POSTAL_CODE.id;
    const isCompanyLevelPreSelected = electionMenuStore.getIsCompanyLevelPreSelected();

    // If switching from Candidates or Postal Code tab to another tab and company level was pre-selected
    const shouldSwitchToCompanyLevel =
        isCandidateOrPostalActiveTab && isNonCandidateOrPostalNewTab && isCompanyLevelPreSelected;

    if (shouldSwitchToCompanyLevel || newTabId === TAB_META.ADMIN.id) {
        electionMenuStore.setIsCompanyLevel(true);
        electionMenuStore.setSelectedElectionMenu(null);
        electionMenuStore.setIsCompanyLevelPreSelected(false);
    }

    switch (newTabId) {
        case TAB_META.ADMIN.id:
            await companyStore.loadCompanyList();
            await adminStore.fetchAdminData();
            break;
        case TAB_META.ADMIN_REPORT.id:
            await adminReportStore.fetchUserVoteCounts();
            break;
        case TAB_META.CANDIDATES.id:
            if (regionStore.selectedRegionId) {
                await candidateStore.getCandidateListByRegionId(regionStore.selectedRegionId);
            }
            break;
        case TAB_META.GENERAL_SETTINGS.id:
            await generalSettingsStore.getRegionById();
            break;
        case TAB_META.POSTAL_CODE.id:
            await zipcodeStore.getZipcodeListAndPagination();
            break;
        case TAB_META.REPORT.id:
            await reportStore.handleFetchReportData();
            break;
    }
};

export default fetchTabData;
